import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VApp, [_vm.showPage ? _c(VForm, {
    ref: "form",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VContainer, {
    class: _vm.loginContainerStyle(),
    attrs: {
      "fluid": ""
    }
  }, [_vm.logoPosition() !== 'center-overlap' && !_vm.isDefaultSvgLogo() ? _c(VRow, {
    attrs: {
      "align": _vm.logoPosition(),
      "justify": _vm.logoDefaultJustify
    }
  }, [_c(VCol, {
    class: `ma-0 pa-0 text-${_vm.logoPosition()}`,
    attrs: {
      "cols": "auto"
    }
  }, [_c('core-logo-custom', {
    attrs: {
      "image": _vm.loginLogo.image,
      "orientation": _vm.loginLogo.orientation
    }
  })], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "dsuite-panel",
    style: _vm.getBG()
  }, [_vm.logoPosition() === 'center-overlap' || _vm.isDefaultSvgLogo() ? _c(VRow, {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCol, {
    staticClass: "pa-0",
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c(VSheet, {
    staticClass: "mx-auto dsuite-dgmnd-logo dsuite-login-bg",
    style: _vm.loginLogoCenteredStyle
  }, [_vm.isDefaultSvgLogo() ? _c('core-logo-niotix', {
    ref: "logoContainer",
    attrs: {
      "width": "100",
      "color": "#00A9E1",
      "dark": _vm.UiTheme
    }
  }) : _c('core-logo-custom', {
    attrs: {
      "image": _vm.loginLogo.image,
      "orientation": _vm.loginLogo.orientation
    }
  })], 1)], 1)], 1) : _vm._e(), _c(VRow, {
    staticClass: "fill-height",
    staticStyle: {
      "margin-top": "-40px !important"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCol, {
    staticClass: "text-center px-12",
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mx-auto",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "pb-10",
    attrs: {
      "cols": "12",
      "align": "left"
    }
  }, [_c('h1', {
    class: {
      'mobile-headline': true,
      'mfa-headline': _vm.showMfaInput
    },
    staticStyle: {
      "color": "#fff",
      "margin-bottom": "-60px"
    }
  }, [_vm._v("\n                    " + _vm._s(!_vm.showMfaInput ? _vm.$i18n_t('Common.signIn') : _vm.$i18n_t('Common.mfaAuth')) + "\n                  ")])]), !_vm.showMfaInput ? [_c(VCol, {
    staticClass: "pt-10 pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c(VTextField, {
    directives: [{
      name: "disabled-icon-focus",
      rawName: "v-disabled-icon-focus"
    }],
    attrs: {
      "data-cy": "email_field",
      "rules": _vm.emailRules,
      "background-color": _vm.themeGetBgColors(),
      "label": _vm.$i18n_t('Common.email'),
      "type": "email",
      "name": "Email",
      "required": "",
      "filled": "",
      "clearable": "",
      "autofocus": ""
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1), _c(VCol, {
    staticClass: "pt-10 pb-0",
    attrs: {
      "cols": "12",
      "md": "5",
      "lg": "5"
    }
  }, [_c('core-password-field', {
    attrs: {
      "data-cy": "password_field",
      "rules": _vm.passwordRules,
      "background-color": _vm.themeGetBgColors(),
      "name": "Password",
      "filled": "",
      "outlined": false,
      "label": _vm.$i18n_t('Common.password'),
      "required": ""
    },
    model: {
      value: _vm.password,
      callback: function ($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  })], 1), _c(VCol, {
    staticClass: "pb-0",
    staticStyle: {
      "padding-top": "11px"
    },
    attrs: {
      "cols": "1"
    }
  }, [_c(VBtn, {
    staticClass: "elevation-0",
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "data-cy": "submit_button",
      "disabled": !_vm.valid,
      "color": _vm.themeGetBgColors(),
      "type": "submit",
      "fab": ""
    }
  }, [!_vm.loading ? _c(VIcon, [_vm._v("fal fa-sign-in")]) : _c(VProgressCircular, {
    attrs: {
      "indeterminate": "",
      "color": _vm.color,
      "width": 3,
      "size": 22
    }
  })], 1)], 1), _c(VCol, {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "md": "11",
      "lg": "11",
      "align": "right"
    }
  }, [_c('router-link', {
    staticStyle: {
      "font-weight": "600"
    },
    attrs: {
      "data-cy": "link_forgot_pwd",
      "to": "/reset-password"
    }
  }, [_c('div', {
    staticClass: "fpwd"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.forgotPwd')))])])], 1)] : _vm._e(), _vm.showMfaInput ? [_c(VCol, {
    staticClass: "pt-10 pb-0",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c(VTextField, {
    directives: [{
      name: "disabled-icon-focus",
      rawName: "v-disabled-icon-focus"
    }],
    attrs: {
      "data-cy": "mfa_token",
      "background-color": _vm.themeGetBgColors(),
      "label": _vm.$i18n_t('Common.mfaTokenLabel'),
      "name": "MfaInput",
      "maxlength": 6,
      "required": "",
      "filled": "",
      "clearable": "",
      "autofocus": ""
    },
    model: {
      value: _vm.mfaToken,
      callback: function ($$v) {
        _vm.mfaToken = $$v;
      },
      expression: "mfaToken"
    }
  })], 1), _c(VCol, {
    staticClass: "pb-0",
    staticStyle: {
      "padding-top": "11px"
    },
    attrs: {
      "cols": "1"
    }
  }, [_c(VBtn, {
    staticClass: "elevation-0",
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "data-cy": "submit_mfatoken",
      "disabled": !_vm.valid,
      "color": _vm.themeGetBgColors(),
      "fab": "",
      "type": "submit"
    }
  }, [!_vm.loading ? _c(VIcon, [_vm._v("fal fa-sign-in")]) : _c(VProgressCircular, {
    attrs: {
      "indeterminate": "",
      "color": _vm.color,
      "width": 3,
      "size": 22
    }
  })], 1)], 1), _c(VCol, {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "md": "11",
      "lg": "11",
      "align": "left"
    }
  }, [_c('div', {
    staticClass: "fpwd subtitle"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.mfaInfoText')))])])] : _vm._e(), [_c(VCol, [_c('core-FederatedLogin', {
    ref: "FederatedLogin",
    staticClass: "mt-2"
  })], 1)]], 2)], 1)])], 1)], 1)], 1)], 1) : _vm._e(), _c('core-footer', {
    attrs: {
      "footerData": _vm.$store.state.app.footer,
      "loginPageVersion": ""
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };